module.exports = __webpack_public_path__ + "img/lg_ring_r_c_1_1.28177fff.png";